import axios from "axios";
import { GURL } from "./global";

export const GetUserProfile = () => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/UserProfile/GetUserProfile`;
  return axios.get(url);
};

export const SetUserProfile = (firstName: any, lastName: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/UserProfile/CompleteProfile`;
  return axios.post(url, { firstName, lastName });
};

export const GetUserProfileById = (id: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/UserProfile/GetUserProfileById?Id=${id}`;
  return axios.get(url);
};
export const GetUserProfileByIds = (userIds: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/UserProfile/GetUserProfileByUserIds`;
  // console.log("use", userIds);

  return axios.post(url, { userIds });
};
